"use client"

import { ADMIN_API_CONFIG } from "@/constants/api-configs"
import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../../lib/helper"

export interface BannerImageProps extends CommonStylesProps {
  backgroundImage: string
  bannerTitle: string
  type: "fluid" | "custom" | "boxed"
}

export const RenderConfig: ComponentConfig<BannerImageProps> = {
  render: ({ className, type, styles, responsiveType, backgroundImage, bannerTitle }) => {
    const id = `banner-image-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)

    return (
      <>
        {responsiveCSS}
        <div
          id={id}
          className={twMerge(className, `relative w-full flex items-center justify-center overflow-hidden`)}
          style={{
            height: "669px",
            backgroundImage: backgroundImage ? `url(${ADMIN_API_CONFIG.API_URL}${backgroundImage})` : "none",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 z-1" style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}></div>

          <div className="relative z-2 text-center px-4">
            <p
              className="m-0"
              style={{
                color: "#FFFFFF",
                fontSize: "48px",
                fontWeight: "700",
                lineHeight: "1.2",
                textShadow: "0px 4px 8px rgba(0, 0, 0, 0.5)",
              }}
            >
              {bannerTitle}
            </p>
          </div>
        </div>
      </>
    )
  },
}
